
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "t": "1726278479139",
    "class": "icon",
    "viewBox": "0 0 1024 1024",
    "version": "1.1",
    "xmlns": "http://www.w3.org/2000/svg",
    "p-id": "4296",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "width": "128",
    "height": "128"
  },
  "children": [
    {
      "tag": "path",
      "attrsMap": {
        "d": "M512 512m-512 0a512 512 0 1 0 1024 0 512 512 0 1 0-1024 0Z",
        "fill": "#FF5050",
        "p-id": "4297"
      }
    },
    {
      "tag": "path",
      "attrsMap": {
        "d": "M240.9472 796.16l-54.784-48.384a387.6864 387.6864 0 0 0 90.9824-262.912v-129.28c-16.128 13.1584-33.024 24.8832-47.616 34.816l-45.4656-54.7328a655.36 655.36 0 0 0 207.5136-206.08l69.632 14.9504c-9.6768 15.7184-18.9952 29.8496-28.3648 43.3152h265.728v48.3328a822.528 822.528 0 0 1-73.216 75.264h193.9968v65.3824h-473.9584v108.032a490.1888 490.1888 0 0 1-104.3968 311.296z m87.3984-484.6592h210.3296c23.2448-19.0976 45.4656-40.4992 71.68-66.816h-220.16a795.4944 795.4944 0 0 1-61.8496 66.816z m163.3792 471.8592c-49.7152 0-73.8816-22.0672-73.8816-66.1504v-273.5616h308.9408v134.3488a62.9248 62.9248 0 0 1-66.56 68.7104q-47.9744 0-91.648-2.1504l-16.4352-63.0272q46.9504 4.3008 80.9984 4.2496c16.3328 0 24.8832-10.6496 24.8832-30.72v-51.712h-171.264v189.0304c0 18.4832 11.3664 28.3648 35.584 28.3648h183.9616q42.5984 0 53.248-17.0496a268.2368 268.2368 0 0 0 15.616-76.8l64.7168 20.48a221.184 221.184 0 0 1-32 117.248 131.2256 131.2256 0 0 1-81.92 18.4832z",
        "fill": "#FFFFFF",
        "p-id": "4298"
      }
    }
  ]
})
    }
  